import { render } from "./slidehand-22.vue?vue&type=template&id=a036b58a&scoped=true"
import script from "./slidehand-22.vue?vue&type=script&lang=js"
export * from "./slidehand-22.vue?vue&type=script&lang=js"

import "./slidehand-22.vue?vue&type=style&index=0&id=a036b58a&lang=scss&scoped=true"

import exportComponent from "/Users/dima/Projects/OrangeStatic/rise-homestories/public/themes/rise-theme/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a036b58a"]])

export default __exports__